// extracted by mini-css-extract-plugin
module.exports = {"layoutContainer":"HeaderWrapper_layoutContainer__2sV3E"};